import React,{useEffect, useState} from "react";
import Navbar from "./Navbar";
import axios from "axios";
import url from "../../function/url";
import Cookies from "js-cookie";
import ReactPaginate from "react-paginate";
import Swal from "sweetalert2";
function NewProductsTelecaller() {
    const ID = Cookies.get("log_id");
    const [Products,setProducts] = useState([]);
    const [selectedProduct,setSelectedProduct] = useState(null);
    const [product,setProduct] = useState(null);
    const [status,setStatus] = useState("");
    const [reason,setReason] = useState("");
    function AssignedProducts() {
        axios.get(`${url.path}/assigned_products/${ID}/`)
        .then((res) =>{
            if(res.data.status){
                var prods = res.data.assigned;
                setProducts([])
                prods.map((p)=>{
                    setProducts((prevState) =>[
                        ...prevState, p
                    ])
                })
            }
        }).catch((err) => {
            console.log("ERROR", err);
          });
    }
    useEffect(() =>{
        AssignedProducts();
    }, [])
    function searchTable(){
        var rows = document.querySelectorAll('#productstable tbody tr');
        var val = document.getElementById('search').value.trim().replace(/ +/g, ' ').toLowerCase();
        rows.forEach(function(row) {
          var text = row.textContent.replace(/\s+/g, ' ').toLowerCase();
          row.style.display = text.includes(val) ? '' : 'none';
        });
      }
      const itemsPerPage = 3;
          const [searchTerm, setSearchTerm] = useState("");
          const [currentPage, setCurrentPage] = useState(0);
      
          const filteredData = Products.filter((item) =>
            item.name.toLowerCase().includes(searchTerm.toLowerCase())
          );
      
          const offset = currentPage * itemsPerPage;
          const currentItems = filteredData.slice(offset, offset + itemsPerPage);
          const pageCount = Math.ceil(filteredData.length / itemsPerPage);
      
          const handlePageClick = ({ selected }) => {
            setCurrentPage(selected);
          };
          const handleOpenModal = (cmp) => {
            setSelectedProduct(cmp);
          };
          const handleCloseModal = () => {
            setSelectedProduct(null);
            
          };
          const handleModal = (cmp) => {
            setProduct(cmp);
          };
          const closeModal = () =>{
            setProduct(null);
          };
          const Toast = Swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.onmouseenter = Swal.stopTimer;
              toast.onmouseleave = Swal.resumeTimer;
            },
        });
        function Approve(e) {
            e.preventDefault();
            const formdata = new FormData();
            formdata.append('id',ID);
            formdata.append('product',selectedProduct.id);
            formdata.append('status',status);
            formdata.append('reason',reason);
            axios.post(`${url.path}/product_decision/`,formdata)
            .then((res) =>{
                if(res.data.status){
                    Toast.fire({
                        icon:'success',
                        title:'Product Approved'
                    })
                    AssignedProducts();
                    handleCloseModal();
                }
            }).catch((err) => {
                console.log("ERROR", err);
              });

        }
        function Disapprove(e) {
            e.preventDefault();
            const formdata = new FormData();
            formdata.append('id',ID);
            formdata.append('product',product.id);
            formdata.append('status',status);
            formdata.append('reason',reason);
            axios.post(`${url.path}/product_decision/`,formdata)
            .then((res) =>{
                if(res.data.status){
                        Toast.fire({
                            icon:'warning',
                            title:'Product Disapproved'
                        })
                    AssignedProducts();
                    closeModal();
                }
            }).catch((err) => {
                console.log("ERROR", err);
              });

        }
    return(
        <>
        <Navbar />
        <center>
            <h3 style={{fontSize:'20px',position:'relative',top:'10px'}}>New Products</h3>
            </center>
            <div className="search-container">
    <input
      type="text"
      placeholder="Search..."
      onKeyUp={searchTable}
      className="search-input"
      id="search"
    />
  </div>
        <div className="table-container">
            
      <table className="responsive-table" id="productstable">
        <thead>
          <tr>
            <th>Sl.No</th>
            <th>Product Name</th>
            <th>Price</th>
            <th>Company Name</th>
            <th>Contact</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {Products.map((i,index) => (
            <tr key={i.id}>
              <td>{index+1}</td>
              <td>{i.name}</td>
              <td>{i.price}</td>
              <td>{i.company}</td>
              <td>{i.contact}</td>
                <td><button type="button" style={{width:'80px',backgroundColor:'green',color:'white',borderRadius:'5px'}} onClick={() => handleOpenModal(i)}>Approve</button>
                <button type="button" style={{width:'100px',backgroundColor:'red',color:'white',borderRadius:'5px',marginLeft:'5px'}} onClick={() =>handleModal(i)}>Disapprove</button>
                </td>
            </tr>
          ))}
        </tbody>
      </table>
      {filteredData.length > itemsPerPage && (
        <ReactPaginate
          previousLabel={"← Previous"}
          nextLabel={"Next →"}
          breakLabel={"..."}
          pageCount={pageCount}
          marginPagesDisplayed={2}
          pageRangeDisplayed={3}
          onPageChange={handlePageClick}
          containerClassName={"pagination"}
          activeClassName={"active"}
        />
      )}
    </div>
    {selectedProduct && (
    <div className="modal-overlay" onClick={handleCloseModal}>
      <div
        className="modal-content"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          className="close-button"
          onClick={handleCloseModal}
        >
          &times;
        </button>
        <h2>Approve Product</h2>
        <p>Are you sure to Approve {selectedProduct.name}</p>
        <form onSubmit={Approve}>
          <center>
          <button type="submit" style={{width:'100px',backgroundColor:'green',borderRadius:'5px',color:'white'}} onClick={() =>setStatus("Approved")}>Approve</button>
          </center>
        </form>
      </div>
    </div>
  )}
  {product && (
    <div className="modal-overlay" onClick={closeModal}>
      <div
        className="modal-content"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          className="close-button"
          onClick={closeModal}
        >
          &times;
        </button>
        <h2>Disapprove Product</h2>
        <p>Are you sure to Disapprove {product.name}</p>
        <form onSubmit={Disapprove}>
        <div className="form-group-row">
              <div className="form-group">
                <label style={{fontSize:'15px'}}>Rejection Reason</label>
                <input type="text" id="reasoninput" onChange={(e) =>setReason(e.target.value)} />
              </div>
            </div>
          <center>
          <button type="submit" style={{width:'100px',backgroundColor:'red',borderRadius:'5px',color:'white'}} onClick={() =>setStatus("Rejected")}>Disapprove</button>
          </center>
        </form>
      </div>
    </div>
  )}
        </>
    );
}
export default NewProductsTelecaller;